<div class="grid-container">
  <div class="grid-x">
    <div class="cell large-12">
      <h3>Application Summary</h3>
    </div>
    <div class="cell large-12">
      You are about to request to initiate an application on behalf of Organization #{{organization?.id}}, {{organization?.name}}.
    </div>
    <div class="cell large-6">
      Submission: <span class="bold">{{applicationModule?.title}}</span>
    </div>
    <div class="cell large-6">
      Type of Application: <span class="bold">{{applicationType?.title}}</span>
    </div>
    <div class="cell large-12">
      Upon clicking the "Generate Application Number" button below, you will be given an application number.  This number is to be used throughout the rest of the process.
    </div>
    <div class="cell large-12 text-align-right">
      <button class="button" (click)="generateApplication()" [disabled]="applicationNumberGenerated">Generate Application Number</button>
    </div>
    <div class="cell large-6">
      @if (applicationNumber) {
        <span>Your application # is: {{applicationNumber}}</span>
      }
    </div>
    <div class="cell large-6 text-align-right">
      <button class="button" (click)="advance()" [disabled]="!applicationNumber">Next</button>
    </div>
  </div>
</div>